import styled from 'styled-components';
import { getTypographyStyles } from '../../utils/index.js';
import { SYS_SIZE_FIXED_25, SYS_SIZE_FIXED_50, SYS_SIZE_FIXED_100, SYS_SIZE_FIXED_450 } from '../../tokens/sizing.generated.js';
import { FormMessage } from '../form-message/index.js';
import { SEM_TYPOGRAPHY_FORMS_APPENDIX, SEM_TYPOGRAPHY_FORMS_INPUT, SEM_TYPOGRAPHY_FORMS_LABEL, SEM_TYPOGRAPHY_FORMS_LABEL_SMALL } from '../../tokens/typography.generated.js';
import { SYS_SPACE_FIXED_150 } from '../../tokens/spacing.generated.js';
export const StyledTextInputContainer = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;
`;
const labelLineHeight = '20.8px';
const inputMinHeight = '36px';
const labelTopPositioning = `calc(${SYS_SIZE_FIXED_450} + ((${inputMinHeight} - ${labelLineHeight}) / 2))`;
export const StyledLabel = styled.label `
  position: absolute;
  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.text.disabled
    : props.invalid
        ? props.theme.sem.color.forms.foreground.text.error
        : props.theme.sem.color.forms.foreground.text.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)}
  gap: ${SYS_SIZE_FIXED_100};
  display: flex;
  align-items: baseline;
  pointer-events: none;
  top: ${labelTopPositioning};
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: top, font-size;
`;
export const StyledInput = styled.input `
  color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_INPUT)}
  background-color: transparent;
  border: 0;
  box-shadow: inset 0px -${SYS_SIZE_FIXED_25} 0px 0px ${(props) => (props.invalid ? props.theme.sem.color.forms.surface.underline.stroke.error : props.theme.sem.color.forms.surface.underline.stroke.default)};

  margin-top: ${SYS_SIZE_FIXED_450};
  min-height: ${inputMinHeight};
  // TODO: missing token
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: box-shadow;

  &:hover {
    color: ${(props) => props.theme.sem.color.forms.foreground.text.interactive};

    box-shadow: inset 0px -${SYS_SIZE_FIXED_25} 0px 0px ${(props) => (props.invalid ? props.theme.sem.color.forms.surface.underline.stroke.error : props.theme.sem.color.forms.surface.underline.stroke.interactive)};
  }

  &:focus {
    outline: auto;
  }

  &:not(:placeholder-shown),
  &:focus,
  &:active:not(:disabled) {
    & + ${StyledLabel} {
      top: 0px;
      ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL_SMALL)}
    }
  }

  &:focus,
  &:active:not(:disabled) {
    box-shadow: inset 0px -${SYS_SIZE_FIXED_50} 0px 0px ${(props) => (props.invalid ? props.theme.sem.color.forms.surface.underline.stroke.error : props.theme.sem.color.forms.surface.underline.stroke.interactive)};
  }

  &:read-only {
    color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
    box-shadow: none;

    & + ${StyledLabel} {
      color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
    }
  }

  &:disabled {
    cursor: not-allowed;
    color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};
    box-shadow: inset 0px calc(-1 * ${SYS_SIZE_FIXED_25}) 0px 0px
      ${(props) => props.theme.sem.color.forms.surface.underline.stroke.disabled};

    & + ${StyledLabel} {
      color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};
    }
  }
`;
export const StyledAppendix = styled.span `
  color: ${(props) => props.theme.sem.color.forms.foreground.text.caption};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_APPENDIX)}
`;
export const StyledFormMessage = styled(FormMessage) `
  padding-top: ${SYS_SPACE_FIXED_150};
`;
//# sourceMappingURL=index.styles.js.map